(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno-xpress/assets/react/init.js') >= 0) return;  svs.modules.push('/modules/keno-xpress/assets/react/init.js');
"use strict";


const GameContainer = svs.kenoXpress.react.GameContainer;
const PlayerRouter = svs.app.ReactRouter.PlayerRouter;
const Route = svs.app.ReactRouter.Route;
const baseUrl = svs.core.data.baseUrl;
const router = React.createElement(PlayerRouter, {
  basename: baseUrl
}, React.createElement(Route, {
  component: () => React.createElement(GameContainer, null),
  exact: true,
  loader: svs.kenoXpress.react.components.Loader,
  path: "/spela"
}), React.createElement(Route, {
  component: () => React.createElement(GameContainer, null),
  loader: svs.kenoXpress.react.components.Loader,
  path: "/demo/:row([0-9,]+)/:price([0-9]+)/:kungkeno(true|false)"
}), React.createElement(Route, {
  component: () => React.createElement(GameContainer, null),
  exact: true,
  loader: svs.kenoXpress.react.components.Loader,
  path: "/mina-spel/:wagerId([0-9]+)"
}), React.createElement(Route, {
  component: () => React.createElement(GameContainer, null),
  exact: true,
  loader: svs.kenoXpress.react.components.Loader,
  path: "/mina-spel/pagaende"
}), React.createElement(Route, {
  component: () => React.createElement(GameContainer, null),
  exact: true,
  loader: svs.kenoXpress.react.components.Loader,
  path: "/mina-spel/pagaende/:wagerId"
}));

svs.kenoXpress.init = () => {
  ReactDOM.render(router, document.getElementById('reactContainer'));
};
svs.kenoXpress.init();

 })(window);